import React from 'react';
import './Input.scss';

export default class Input extends React.Component {

  constructor(props) {
    super(props);

    this.id = Math.random().toString(36).substr(2);
  }

  getRootClass() {
    return 'row ComponentInput ' + (this.props.className || '');
  }

  handleChange(e) {
    if (this.props.onChange) {
      this.props.onChange(['checkbox', 'radio'].includes(e.target.type) ?
          e.target.checked :
          e.target.value);
    }
  }

  render() {
    return (
        <div className={this.getRootClass()}>
          <div className="col-lg-4 col-md-4">
            <div style={
              this.props.labelIndented ?
                  {'paddingLeft': '70px'} :
                  null
            }>
              <label htmlFor={this.id}>{this.props.label}</label>
            </div>
          </div>
          <div className="col-lg-7 col-md-7" style={{'position': 'relative'}}>
            {this.props.children || (
                ['checkbox', 'radio'].includes(this.props.type) ?
                    (<div className="form-field">
                      <input className="field-wrap"
                             type={this.props.type}
                             checked={this.props.checked}
                             defaultChecked={this.props.defaultChecked}
                             onChange={this.handleChange.bind(this)}
                             style={{display: 'block'}}
                             disabled={this.props.disabled}
                             id={this.id}
                      />
                    </div>) :
                    (<div className="form-field">
                      <input className="field-wrap"
                             type={this.props.type || 'text'}
                             value={this.props.value}
                             disabled={this.props.disabled}
                             defaultValue={this.props.defaultValue}
                             onChange={this.handleChange.bind(this)}
                             id={this.id}
                      />
                    </div>)
            )}
          </div>
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Input.js